import { Box, Divider, IconButton, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../shared/sagas/auth/authSlice';
import { selectPropertyGroupDetailsState } from '../../shared/sagas/propertyGroups/propertyGroupsSlice';
import backIcon from '../../icons/backIcon.svg';
import { AssignedConfigsDto, Role } from '@inosio/payments-sdk';

export default function PropertyGroupConfiguration(props: { Uuid: string }) {
  const hasOnSwitch = true;
  const { allPropertyGroupsAssignedConfigs, propertyGroups } = useSelector(selectPropertyGroupDetailsState);
  const currentUser = useSelector(selectCurrentUser);
  const history = useHistory();
  const propertyGroupAssignedConfigs = allPropertyGroupsAssignedConfigs.find(apgac => apgac.Uuid === props.Uuid) || {} as AssignedConfigsDto;

  const propertyGroupName = propertyGroups?.find((pg) => pg.Uuid === props.Uuid)?.Description;

  return (
    <>
      <Box sx={{ '.MuiTypography-root': { fontFamily: 'Work Sans' } }}>
        <Stack direction="row" alignItems="baseline">
          {propertyGroups?.length > 1 && <IconButton
            sx={{ marginRight: '10px', marginTop: '-4px' }}
            onClick={() => {
              history.push(`/pmui/propertygroups`);
            }}
          >
            <img src={backIcon} alt="" height="14px" />
          </IconButton>}
          <Typography sx={{ margin: '2% 0 16px', fontWeight: '800', fontSize: '18px' }}>{propertyGroupName} Property Group</Typography>
        </Stack>
        <Divider sx={{ bottomBorderWidth: '1px', borderColor: '#000' }} />
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          {currentUser?.currentProfile.role && [Role.PropertyManagerAdmin].includes(currentUser?.currentProfile.role)? (
            <>
              <ConfigurationTile {...{ options: ['Payment Types', 'Payment Restrictions', 'Recurring Payments'], header: 'Payments', hasOnSwitch, productEnabled: propertyGroupAssignedConfigs.PaymentsProductPurchased, headerColorHex: '#053742' }} />
              <ConfigurationTile {...{ options: ['Application', 'Application Fee Amount', 'Payment Types', 'Pet Details'], header: 'Applications', hasOnSwitch, productEnabled: propertyGroupAssignedConfigs.ApplicationsProductPurchased, headerColorHex: '#BE6531' }} />
              {/* disabling billing tile out for now */}
              {/* <ConfigurationTile {...{ options: ['Plan', 'Billing Configuration'], header: 'Billing', hasOnSwitch: !hasOnSwitch, headerColorHex: '#0A998D' }} /> */}
            </>
          ) : (
            <></>
          )}
          <ConfigurationTile {...{ options: ['Maintenance Policies', 'Emergency Contact Number'], header: 'Maintenance', hasOnSwitch, productEnabled: propertyGroupAssignedConfigs.MaintenanceProductPurchased, headerColorHex: '#A4243B' }} />
          <ConfigurationTile {...{ options: ['Configure Go Live Date'], header: 'OwnerPortal', hasOnSwitch, productEnabled: propertyGroupAssignedConfigs.OwnerPortalProductPurchased, headerColorHex: '#26ab7f' }} />
        </Box>
      </Box>
    </>
  );
}

function ConfigurationTile(props: { header: string; options: string[]; hasOnSwitch: boolean; productEnabled?: boolean; headerColorHex?: string; disabled?: boolean }) {
  const history = useHistory();
  const { url } = useRouteMatch();

  const goToPage = (relPath: string) => {
    history.push(`${url}/${relPath}`);
  };

  return (
    <>
      <Box onClick={!props.disabled ? () => goToPage(props.header.toLowerCase()) : () => { }} sx={{ cursor: 'pointer', boxSizing: 'border-box', borderRadius: '24px', overflow: 'hidden', width: '412px', height: '217px', margin: '16px 2% 16px 0' }}>
        <Stack direction={'row'} sx={{ background: props.headerColorHex, padding: '14px 0 12px 16px', color: '#fff' }}>
          <Typography sx={{ width: '90%', textAlign: 'left', fontWeight: '800' }}>{props.header?.split(/(?=[A-Z])/).join(' ')}</Typography>
          {props.hasOnSwitch ? <Typography sx={{ background: '#fff', color: '#000', lineHeight: '22px', padding: '1px 8px', marginRight: '10px', borderRadius: '24px' }}>{props.productEnabled ? 'On' : 'Off'}</Typography> : <></>}
        </Stack>
        <List dense={true} sx={{ background: '#fff', height: 'inherit', paddingLeft: '2%' }}>
          {props.options.map((option) => {
            return (
              <ListItem key={option}>
                <ListItemText primary={option} />
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
}
